import { combineReducers } from 'redux';
import generalConfig from "./generalConfig";
import user from "./user";
import appData from "./appData";

export default combineReducers({
    generalConfig: generalConfig,
    user: user,
    appData: appData
})